import React, { JSX, FC } from "react";
import { Button, Modal } from "antd";

interface IInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string | JSX.Element;
  children: JSX.Element;
}

const InfoModal: FC<IInfoModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
}): JSX.Element => {
  return (
    <Modal
      width={572}
      open={isOpen}
      footer={null}
      centered
      onCancel={onClose}
      maskStyle={{ backgroundColor: "rgba(103, 118, 140, 0.5)" }}
    >
      <h5 className="mb-5 font-medium">{title}</h5>
      {children}
      <div className="flex justify-end mt-5">
        <Button onClick={onClose}>Закрыть</Button>
      </div>
    </Modal>
  );
};

export default InfoModal;
